import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;
let socketConsumers = 0;

export const getAppSocket = (): Socket => {
  if (socket) {
    socketConsumers += 1;
    return socket;
  }
  const token = localStorage.getItem('token');
  socket = io({
    auth: {
      token: token || ''
    }
  });
  socketConsumers = 1;
  return socket;
};

export const disconnectAppSocket = () => {
  if (!socket) return;
  socketConsumers = Math.max(0, socketConsumers - 1);
  if (socketConsumers > 0) return;
  socket.disconnect();
  socket = null;
};

// Backward-compat aliases
export const getWesSocket = getAppSocket;
export const disconnectWesSocket = disconnectAppSocket;
